import type * as Types from '../../../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type SearchBannerFragment = {
  __typename?: 'SearchBanner';
  id: string;
  title?: string | null;
  text?: string | null;
  backgroundColor?: string | null;
  visible?: boolean | null;
  categoryId?: string | null;
  keyword?: string | null;
  url?: Array<string> | null;
  aiGenerated: boolean;
  image?: {
    __typename?: 'Image';
    url?: string | null;
    id?: string | null;
    vw1280?: string | null;
    vw500?: string | null;
    vw600?: string | null;
    vw800?: string | null;
    vw1024?: string | null;
    thumbnail?: string | null;
  } | null;
  category?: { __typename?: 'Category'; id?: string | null; normalizedName?: string | null } | null;
  relatedSearchBanners?: Array<{
    __typename?: 'SearchBanner';
    id: string;
    aiGenerated: boolean;
    title?: string | null;
    text?: string | null;
    visible?: boolean | null;
    categoryId?: string | null;
    keyword?: string | null;
    url?: Array<string> | null;
    category?: { __typename?: 'Category'; id?: string | null; normalizedName?: string | null } | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null; preview?: string | null } | null;
  }> | null;
};

export type SearchBannerQueryVariables = Types.Exact<{
  input: Types.SearchBannerInput;
}>;

export type SearchBannerQuery = {
  __typename?: 'Query';
  searchBanner?: {
    __typename?: 'SearchBanner';
    id: string;
    title?: string | null;
    text?: string | null;
    backgroundColor?: string | null;
    visible?: boolean | null;
    categoryId?: string | null;
    keyword?: string | null;
    url?: Array<string> | null;
    aiGenerated: boolean;
    image?: {
      __typename?: 'Image';
      url?: string | null;
      id?: string | null;
      vw1280?: string | null;
      vw500?: string | null;
      vw600?: string | null;
      vw800?: string | null;
      vw1024?: string | null;
      thumbnail?: string | null;
    } | null;
    category?: { __typename?: 'Category'; id?: string | null; normalizedName?: string | null } | null;
    relatedSearchBanners?: Array<{
      __typename?: 'SearchBanner';
      id: string;
      aiGenerated: boolean;
      title?: string | null;
      text?: string | null;
      visible?: boolean | null;
      categoryId?: string | null;
      keyword?: string | null;
      url?: Array<string> | null;
      category?: { __typename?: 'Category'; id?: string | null; normalizedName?: string | null } | null;
      image?: { __typename?: 'Image'; url?: string | null; id?: string | null; preview?: string | null } | null;
    }> | null;
  } | null;
};

export const SearchBannerDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchBanner' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchBannerInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBanner' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SearchBanner' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SearchBanner' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchBanner' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'vw1280' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '1280x1280', block: false },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'vw500' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '500x500', block: false },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'vw600' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '600x600', block: false },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'vw800' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '800x800', block: false },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'vw1024' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '1024x1024', block: false },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'thumbnail' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '80x80', block: false },
                    },
                  ],
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'visible' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categoryId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'keyword' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'normalizedName' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aiGenerated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relatedSearchBanners' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aiGenerated' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'text' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visible' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'normalizedName' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'keyword' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'preview' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '160x160', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class SearchBannerGQL extends Apollo.Query<SearchBannerQuery, SearchBannerQueryVariables> {
  document = SearchBannerDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
